// @ts-nocheck f1985ea5
import * as addPanel from '#packages/oldAddPanel';

export default {
  getDesignSections() {
    return {
      titles: ['add_section_label_slider'],
      sections: [addPanel.sections.getSections().developer.sliderSection],
    };
  },
};
